import React from 'react';
import AdminNav from '../AdminNav/AdminNav';
import Header from '../Header/Header';
import ManageProduct from '../../components/ManageProduct/ManageProduct';
import { Table } from 'react-bootstrap';

const ManageBooks = (props) => {


    console.log("result manage book", props.pd.name);

    const {name,price,_id} = props.pd;
    
    return (
        <div>
         
         <Table responsive="sm">
            <tr>

            
                <td><strong>{name}</strong></td>
                <td>1</td>
                <td><strong>{price} Tk</strong></td>
                <td> <button  onClick={()=> props.deleteProducts(_id)} className='btn btn-danger'>delete</button> </td>

                
            </tr>
        


        </Table>
        </div>
    );
};

export default ManageBooks;